import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

// Shown to guests (Play as guest, Jack 2026-10-19): what they're missing and
// a way to keep their games by creating an account.
export default function GuestBanner({ className = "" }) {
  const { user } = useAuth();
  if (!user?.is_guest) return null;
  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center gap-3 p-5 rounded-2xl border border-border bg-surface ${className}`}
      data-testid="guest-banner"
    >
      <div className="flex-1 min-w-0">
        <div className="font-display font-bold tracking-tight">You're playing as {user.username}.</div>
        <div className="text-sm text-muted-foreground">
          Create an account to add friends, get on the leaderboard and sign in on other devices. Your games and Elo come with you.
        </div>
      </div>
      <Button asChild className="rounded-full bg-brand hover:bg-brand-hover text-brand-foreground flex-none" data-testid="guest-create-account">
        <Link to="/register">Create account</Link>
      </Button>
    </div>
  );
}
